export function approvalSection(type) {
  if (type === "tardy") return "absence";
  if (["plan_task", "plan_task_1448_first", "plan_task_1448_second"].includes(type)) return "plan_task";
  if (["guidance_committee_member", "guidance_committee_meeting"].includes(type)) return "guidance_committee";
  if (["student_council_roster", "student_council_meeting"].includes(type)) return "student_council";
  return type;
}
